import PlayerEdit from './PlayerEdit';

const PlayerPages = { edit: PlayerEdit };
export default PlayerPages;
